import React from 'react';
import { useSelector } from 'react-redux';

import ContentBlock from '../../structure/ContentBlock';
import { TextBlockRichContentSection } from '../../structure/ContentBlock.styled';

import { TabCard, TabHeading, TabCardPanel, TabContentContainer } from '../TabContent.styled';
import EmbeddedVideoView from '../../../../../components/EmbeddedVideoView';
import { hasProgramFeatureAccessPermission } from '../../../../../helpers/CommonHelper';

export default function Eligibility() {
  const eligibility = useSelector(state => state.programBrochure.eligibility);
  const eligibility_video_url = useSelector(state => state.programBrochure.eligibility_video_url);

  const {
    meta: { authorized, premium_program_feature_access },
  } = useSelector(state => state.programBrochure);
  const { clientFeatureList } = useSelector(state => state.profile);

  const { hasPremiumAccess } = hasProgramFeatureAccessPermission(authorized, premium_program_feature_access, clientFeatureList.premium_program_feature_access)


  // const hasPremiumAccess = clientFeatureList?.premium_program_feature_access === true;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = eligibility;
  const updatedContent = tempDiv.textContent || tempDiv.innerText;    
  
  return (
    <TabContentContainer>
      <TabHeading level={2}>Eligibility</TabHeading>
      <TabCard>
        <TabCardPanel className="full">
          {updatedContent?.trim()?.length>0 &&
            <ContentBlock>
              <TextBlockRichContentSection sectionContent={eligibility} />
            </ContentBlock>
          }
          {(eligibility_video_url && hasPremiumAccess) && <div style={{ marginTop: "1.5rem" }}><EmbeddedVideoView url={eligibility_video_url} /></div>}

        </TabCardPanel>
      </TabCard>
    </TabContentContainer>
  );
}
